module.exports = __webpack_public_path__ + "static/media/redcross.3f0a3d82.svg";